(function () {
    'use strict';

    angular
        .module('blocks.filters')
        .filter('noteDateDisplay', noteDateDisplay);


    function noteDateDisplay() {
        return function (input) {
            var local = moment.utc(input).toDate();
            return moment(local).format("MMM DD [at] hh:mm A");
        }
    }

})();

